module.exports = __webpack_public_path__ + "static/media/cq_esporta b.bbb9e568.svg";